import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import {
  ErrorResponse,
  MessageErrorResponse
} from "../../../../../requests/@types";
import api from "../../../../../services/api";
import { ReportCloudSandbox } from "../../../../samples_cloud/@types";
import { RLCSMergedReportResponse } from "../../../@types/rldynamicanalysis/rlcs-responses";
import { sampleReportKeys } from "../../../queryKeys";

export const defaultMergedReportConfig = (
  hash: string,
  isNetworkReport?: boolean
) => ({
  queryKey: sampleReportKeys.mergedReportKey(hash, isNetworkReport),
  queryFn: () => api.rlSandboxMergedReport(hash, isNetworkReport),
  select: ({ data }: AxiosResponse<ReportCloudSandbox>) => data,
  enabled: Boolean(hash)
});
export const useGetMergedRlcsReport = (
  hash: string,
  isNetworkReport = false,
  options?: UseQueryOptions
) => {
  const {
    data: mergedReportData,
    isLoading: isLoadingMerged,
    refetch: refetchMergedReport,
    isSuccess,
    isFetched,
    error
  } = useQuery({
    ...defaultMergedReportConfig(hash, isNetworkReport),
    ...(options ?? {})
  });
  return {
    mergedReportData: mergedReportData as RLCSMergedReportResponse,
    isLoadingMerged,
    isSuccess,
    isFetched,
    refetchMergedReport,
    error: error as ErrorResponse<MessageErrorResponse> | null
  };
};
